export default __webpack_public_path__ + "static/media/dk.b0cd616a.svg";